import {
  Module,
  VuexModule,
  Action,
  Mutation,
  MutationAction,
} from 'vuex-module-decorators';

const defaultAlert = () => ({
  isAlert: false,
  alertMsg: '',
  alertColor: '',
});

@Module({ name: 'general' })
export default class General extends VuexModule {
  alert = defaultAlert();

  isLoading = false;

  @Mutation
  mutateAlert(data) {
    this.alert = data;
  }

  @Action({ commit: 'mutateAlert' })
  async ShowAlert(alert) {
    setTimeout(() => {
      this.context.dispatch('CloseAlert');
    }, 2500);
    return alert;
  }

  @Action({ commit: 'mutateAlert' })
  async CloseAlert() {
    return defaultAlert();
  }

  @MutationAction({ mutate: ['isLoading'] })
  async toggleLoading(val) {
    return {
      isLoading: val,
    };
  }
}
